import { Button, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const NewRvpMessageAlert = () => {
  const [alert, setShowAlert] = React.useState(false);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  React.useEffect(() => {
    const newMessageRvpResponseLocalStorage = JSON.parse(localStorage.getItem('show_new_rvp_message'));

    if (!newMessageRvpResponseLocalStorage) setShowAlert(true);
  }, []);

  function handleCloseAlert() {
    localStorage.setItem('show_new_rvp_message', JSON.stringify(true));
    setShowAlert(false);
  }

  if (!user?.producer || !alert) return null;

  return (
    <>
      <Alert severity='info'>
        <AlertTitle>
          <strong>Aviso sobre novos e-emails e SMS de recuperação!</strong>
        </AlertTitle>
        <Typography>
          Foi ajustado o texto de todos os seus e-mails e SMS. Agora, a comunicação das mensagens está contemplando também as tentativas de vendas com
          pagamentos via cartão e pix, além de boleto. Caso tenha mensagens personalizadas, você ainda pode reutiliza-las reativando.
        </Typography>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
          <Button variant='outlined' color='secondary' onClick={handleCloseAlert}>
            Entendi
          </Button>
        </div>
      </Alert>
      <div className='m16' />
    </>
  );
};

export default NewRvpMessageAlert;
